import { useEffect, useState } from "react"
import { useSearchParams } from "react-router"

import { Toast } from "../components/Toast"

export const useIsCheckoutSuccess = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [isCheckoutSuccess, setIsCheckoutSuccess] = useState(false)

  useEffect(() => {
    if (searchParams.has("checkout-success")) {
      searchParams.delete("checkout-success")

      setSearchParams(searchParams, { replace: true })

      setIsCheckoutSuccess(true)

      Toast.success("Congrats! Your NCX purchase was successful.")
    }
  }, [searchParams, setSearchParams])

  return isCheckoutSuccess
}
